import React, { Component } from "react";
import defaultBcg from "../images/business-1.jpg";
// import Hero from "../components/Hero";
import Banner from "../components/Banner";
import { Link } from "react-router-dom";
import { BusinessContext } from "../context";
import StyledHero from "../components/StyledHero";
import AwardIcon from "../components/AwardIcon";

export default class SingleBusiness extends Component {
  constructor(props) {
    super(props);
    console.log(this.props);
    this.state = {
      slug: this.props.match.params.slug,
      defaultBcg: defaultBcg
    };
  }
  static contextType = BusinessContext;

  // componentDidMount() {
  //   console.log(this.props);
  // }
  render() {
    const { getBusiness } = this.context;
    const business = getBusiness(this.state.slug);

    if (!business) {
      return (
        <div className="error">
          <h3> no businesses could be found...</h3>
          <Link to="/businesses" className="btn-primary">
            back to businesses
          </Link>
        </div>
      );
    }
    const {
      name,
      description,
      capacity,
      size,
      price,
      downpayment,
      grosssales,
      cashflow,
      inventoryatcost,
      extras,
      breakfast,
      pets,
      images
    } = business;
     // eslint-disable-next-line
    const [main, ...defaultImages] = images;
    console.log(defaultImages);

    return (
      <>
        <StyledHero img={images[0] || this.state.defaultBcg}>
          <Banner title={`${name} business`}>
            <Link to="/businesses" className="btn-primary">
              back to businesses
            </Link>
          </Banner>
        </StyledHero>
        <section className="single-business">
          <div className="single-business-images">
            {defaultImages.map((item, index) => (
              <img key={index} src={item} alt={name} />
            ))}
          </div>
          <div className="single-business-info">
            <article className="desc">
              <h3>details</h3>
              {/* <p>{description}</p> */}
              <h6>Details as Array </h6>
                
                  {description.map((item, index) => (
                    <div key={index}>- {item} </div>
                  ))}
          </article>
            <article className="info">
              <h3>info</h3>
              <h6>
                price: {new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
              }).format(price)}</h6>
              <h6>down payment: {new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
              }).format(downpayment)}</h6>
              <h6>gross sales: {new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
              }).format(grosssales)}</h6>
              <h6>cash flow: {new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
              }).format(cashflow)}</h6>
              <h6>inventory at cost: {new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
              }).format(inventoryatcost)}</h6>
              <h6>size: {new Intl.NumberFormat("en-US", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
              }).format(size)} SQFT</h6>
              <h6>
                Established:
                {capacity > 1 ? ` ${capacity} years` : `${capacity} year or less`}
              </h6>
              {/* { <h6>
                valuations<i style={{ color: 'blue' }}>
                  <AwardIcon width='20px' height='20px'></AwardIcon></i><br></br>
              </h6> <p>
              {pets ? "Equipment valuation available" : "no valuation"}<br></br>
                {breakfast && "Business valuation available"}</p> } */}
              
            </article>
          </div>
        </section>
        
        {/* <section className="business-extras">
          <h6>extras </h6>
          <ul className="extras">
            {extras.map((item, index) => (
              <li key={index}>- {item}</li>
            ))}
          </ul>
        </section> */}
      </>
    );
  }
}
